import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Grid3x3, Heart, Calendar, CheckSquare, MessageCircle, HelpCircle } from 'lucide-react';
import { ThemeConfig, NavTab } from '../types';

interface NavigationProps {
  theme: ThemeConfig;
}

const Navigation: React.FC<NavigationProps> = ({ theme }) => {
  const location = useLocation();
  const tabs: NavTab[] = [
    { id: '/', label: 'My Space', icon: Home },
    { id: 'things', label: 'Things in My Space', icon: Grid3x3 },
    { id: 'favorites', label: 'Favorites', icon: Heart },
    { id: 'calendar', label: 'Calendar', icon: Calendar },
    { id: 'todos', label: 'To-Dos', icon: CheckSquare },
    { id: 'chat', label: 'Chat', icon: MessageCircle },
    { id: 'question', label: 'Question', icon: HelpCircle }
  ];

  return (
    <nav className={`${theme.primary} border-b ${theme.border} sticky top-[73px] z-40`}>
      <div className="container mx-auto px-4">
        <div className="flex overflow-x-auto hide-scrollbar">
          {tabs.map(tab => (
            <Link
              key={tab.id}
              to={tab.id}
              className={`flex items-center gap-2 px-4 md:px-6 py-3 whitespace-nowrap transition-all ${
                location.pathname === `/${tab.id}` || (location.pathname === '/' && tab.id === '/')
                  ? `${theme.accent} text-white`
                  : `${theme.textLight} hover:${theme.accent} hover:text-white`
              }`}
            >
              <tab.icon className="w-5 h-5" />
              <span className="font-medium">{tab.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;